import moment from 'moment';

export const isDateInRange = (filter, date) => {
  const today = moment({});
  const d = moment(date);
  switch (filter) {
    case 'Last 3 months':
      return d.isSameOrAfter(moment(today).add(-3, 'M'));
    case 'Last 6 months':
      return d.isSameOrAfter(moment(today).add(-6, 'M'));
    case 'Last 9 months':
      return d.isSameOrAfter(moment(today).add(-9, 'M'));
    case 'All':
    default:
      return true;
  }
};
